import { EXPENSE_TRANSACTION_ERROR,EXPENSE_TRANSACTION_SUCCESS,EDIT_EXPENSE_TRANSACTION } from './actionTypes';

const initialState = {
    error: "",
    success : ""
}

const ExpenseTransaction = (state = initialState, action) => {
    switch (action.type) {
        case EDIT_EXPENSE_TRANSACTION:
            state = { ...state }
            break;
        case EXPENSE_TRANSACTION_SUCCESS:
            state = { ...state, success: action.payload }
            break;
        case EXPENSE_TRANSACTION_ERROR:
            state = { ...state, error: action.payload };
            break;
        default:
            state = { ...state };
            break;
    }
    return state;
}

export default ExpenseTransaction;